/**
 * @description Handles error message generation
 *
 * @param {string} key - Key represents attribute name of button.
 * @param {string} value - Value represents attribute value received from the input.
 */
export const throwErrorMessage = (
  componentName: string,
  id: string,
  key: string,
  value: any,
  DEFAULT_VALUES: any
): void => {
  console.error(
    `${componentName} with ID '${id}' has incorrect type/value for '${key}' property. Received '${value}' of type '${typeof value}'. Using default value '${DEFAULT_VALUES}' of type '${typeof DEFAULT_VALUES}'.`
  );
};
